import { useReducedMotion } from 'framer-motion';

/**
 * Returns true when the OS has prefers-reduced-motion: reduce set.
 * Thin wrapper so we have one import path across the codebase.
 */
export function useReducedMotionPreferred() {
  return useReducedMotion() === true;
}
